/*
 * @Author: jiyuhang
 * @LastEditors: jiyuhang
 * @Date: 2021-10-12 15:54:04
 * @LastEditTime: 2021-11-18 10:45:48
 * @FilePath: /inspector-m/src/store/ncstock.js
 * @Description: In User Settings Edit
 */
import { getShopGrayStatus } from '@/services/nc.stock.service'

export default {
  namespaced: true,
  state: {
    carStatus: null,
    carNumber: null,
    photoStatus: null,
    photoSearchValue: '',  // 当前搜索的数据
    photoHideTabLine: false, // 是否隐藏tab栏下面的线
    grayStatus: null, // 灰度状态
  },
  getters: {
    carStatus: state => state.carStatus,
    photoStatus: state => state.photoStatus,
    carNumber: state => state.carNumber,
    photoSearchValue: state => state.photoSearchValue,
    photoHideTabLine: state => state.photoHideTabLine,
    grayStatus: state => state.grayStatus,
  },
  mutations: {
    SET_GRAY_STATUS (state, data) {
      state.grayStatus = data
    },
    CARSTATUS (state, data) {
      state.carStatus = data
    },
    PHOTOSTATUS (state, data) {
      state.photoStatus = data
    },
    CARNUMBER (state, data) {
      state.carNumber = data
    },
    setPhotoSearchValue (state, data) {
      state.photoSearchValue = data
    },
    setPhotoHideTabLine (state, data) {
      state.photoHideTabLine = data
    },
  },
  actions: {
    setGrayStatus ({ commit }, data) {
      commit('SET_GRAY_STATUS', data)
    },
    async getNcStockShopGrayStatus ({ commit }) {
      try {
        const { data } = await getShopGrayStatus()
        commit('SET_GRAY_STATUS', data)
      } catch (error) {
        commit('SET_GRAY_STATUS', false) // 默认 false
      }
    },
    setCarStatus ({ commit }, data) {
      commit('CARSTATUS', data)
    },
    setPhotoStatus ({ commit }, data) {
      commit('PHOTOSTATUS', data)
    },
    setCarNumber ({ commit }, data) {
      commit('CARNUMBER', data)
    }
  }
}
